/* ce-variant-reactive — keeps ce- custom-liquid blocks in sync with
   variant selection. Custom cultureEDIT file (not part of Horizon).

   On variant change Horizon fetches the fully re-rendered product
   section (?variant=ID) but only morphs the variant picker from it;
   price/buttons update via their own components and arbitrary
   Liquid blocks (stock line, SAVE chip, condition badge) go stale.
   This listens for the same ProductSelectEvent and swaps every
   [data-ce-reactive] element with its counterpart from the fetched
   document — no extra requests, server-rendered truth. */
import { StandardEvents } from '@shopify/events';

document.addEventListener(StandardEvents.productSelect, (event) => {
  event.promise
    ?.then(({ detail }) => {
      const html = detail?.html;
      if (!html) return;
      for (const el of document.querySelectorAll('[data-ce-reactive]')) {
        const key = el.getAttribute('data-ce-reactive');
        const fresh = html.querySelector(`[data-ce-reactive="${CSS.escape(key)}"]`);
        if (fresh) el.replaceWith(document.importNode(fresh, true));
      }
      // Swapped-in klarna-placement tags need Klarna OSM to re-scan.
      window.Klarna?.OnsiteMessaging?.refresh?.();
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[ce-variant-reactive]', error);
    });
});
